"use client";

import { c as _c } from "react/compiler-runtime";
import { IconLoader2 } from "@tabler/icons-react";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * The one-click reorder's in-flight panel
 */
export function ReorderPreparing() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconLoader2 className="size-10 animate-spin" aria-hidden="true" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-1"><p className="text-lg font-medium text-foreground">Preparing your reorder</p><p className="text-sm">This takes a moment while we confirm pricing and shipping.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="size-[100px] shrink-0 bg-neutral-200" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div role="status" data-testid="reorder-preparing" className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center text-muted-foreground">{t0}{t1}<div className="flex w-full gap-5" data-testid="reorder-preparing-placeholder">{t2}<div className="flex flex-1 flex-col gap-3"><Skeleton className="h-5 w-3/4 bg-neutral-200" /><Skeleton className="h-4 w-1/3 bg-neutral-200" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}